import { Avatar, Box, Flex, Text } from '@chakra-ui/react';
import { EntryComponentProps } from '@draft-js-plugins/mention/lib/MentionSuggestions/Entry/Entry';
import * as React from 'react';

type IEntryProps = EntryComponentProps;
export const Entry: React.FC<IEntryProps> = (props) => {
  const { mention, isFocused, theme, searchValue, ...parentProps } = props;

  return (
    <Box {...parentProps} pb="8">
      <Flex alignItems="center" w="full">
        <Avatar
          src={mention.avatar || undefined}
          name={mention.name}
          boxSize={10}
          mr="2"
        />
        <Box display={[null, 'flex']} flex="1">
          <Box flex="1">
            <Text color="gray.700" fontWeight="semibold">
              {mention.name}
            </Text>
            {(mention.company || mention.jobTitle) && (
              <Text color="gray.500">
                {mention.jobTitle}
                {mention.company && mention.jobTitle ? ` at ` : ''}
                {mention.company}
              </Text>
            )}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};
